<div class="dialog {{data.type}}" *ngIf="data">

    <div class="container">

        <div class="content">
            <h2>{{data.title}}</h2>
            <h5>{{data.question}}</h5>
        </div>

        <div *ngIf="!data.isTypeAlert" class="confirm-commands">
            <button class="btn-confirm" (click)="confirm()">{{data.confirmTitle}}</button>
            <button class="btn-confirm btn-cancel" (click)="cancel($event)">{{data.cancelTitle}}</button>
        </div>

        <div *ngIf="data.isTypeAlert" class="confirm-commands">
            <button class="btn-confirm" (click)="confirm()">{{data.okTitle}}</button>
        </div>

    </div>

</div>